import type { ReactElement } from 'react'

import './index.scss'

const MandatoryStar = (): ReactElement => {
  return <span className="mandatory-star">*</span>
}

export default MandatoryStar
